module.exports = __webpack_public_path__ + "img/upload.8d59f5c5.svg";